export default {
  mounted() {
    const { to, onSuccessJs, onErrorJs } = this.el.dataset

    this.el.addEventListener('click', ev => {
      ev.preventDefault()
      if (navigator.clipboard) {
        navigator.clipboard.writeText(to).then(() => {
          console.log('Copied value to clipboard:', to)
          onSuccessJs && this.liveSocket.execJS(this.el, onSuccessJs)
        })
      } else {
        console.log('Value not copied to clipboard. Must be connected through HTTPS:', to)
        onErrorJs && this.liveSocket.execJS(this.el, onErrorJs)
      }
    })
  },
}
